import React, { useEffect, useRef } from "react";
import { useWmsContext } from "../../Contexts/WmsContext";
import { MenuItem } from "../Toc/MenuItem";
import { ILayerState } from "../config";
import { LayerAction } from "../enums";
import { useMapContext } from "../../Contexts/MapContext";

export const WmsLayers = (): JSX.Element => {
    const { wmsState } = useMapContext();
    const { onToggle, onRemoveLayer } = useWmsContext();

    const listRef = useRef<HTMLDivElement>();

    useEffect(() => adjustHeight(), [wmsState]);

    const adjustHeight = () => {
        let delta = 0;
        const accordionElements = document.getElementById("widget-popup").getElementsByClassName("accordion-item");
        for (let i = 0; i < accordionElements.length - 1; i++) {
            delta += accordionElements[i].scrollHeight;
        }
        const maxHeight = document.body.scrollHeight - delta;

        listRef.current.style.maxHeight = maxHeight + "px";
    };

    return (
        <div className="scrollable-content-container">
            <div className="scrollable-content wms-layers" ref={listRef}>
                {wmsState &&
                    wmsState.map((layer) => (
                        <MenuItem
                            key={layer.id}
                            layer={layer as unknown as ILayerState}
                            onToggle={(id: string, layerAction: LayerAction) => onToggle(layer, id, layerAction)}
                            onClickLayerMetadata={() => console.log("showLayerMetadata")}
                            onClickGroupVisibility={(id: string, state: any) => {
                                // setGroupVisibility(id, state);
                            }}
                            buttonNode={
                                <div className="wms-delete-layer" onClick={() => onRemoveLayer(layer.id)}>
                                    <span className="icon-geolite-trash"></span>
                                </div>
                            }
                        ></MenuItem>
                    ))}
            </div>
        </div>
    );
};
